export enum CanyonTypeEnum {
    Unknown=0,
    Sports=1,
    Adventure=2,
    GorgeWalk=3,
    Dry=4
}

export const CanyonTypeList: CanyonTypeEnum[] = [CanyonTypeEnum.Unknown, CanyonTypeEnum.Sports, CanyonTypeEnum.Adventure, CanyonTypeEnum.GorgeWalk, CanyonTypeEnum.Dry];